// extracted by mini-css-extract-plugin
export default {"title":"ListHeader_title__wn9Zt"};